<template>
  <vs-row>
    <vs-spacer /><vs-button
      color="warning"
      @click="default_time()"
      class="mr-2"
      style="border-radius: 30px"
      type="filled"
      >Time Interval</vs-button
    >
    <vs-popup
      class="holamundo"
      title="Time Interval"
      :active.sync="popupActivo"
    >
      <vs-row vs-w="12">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="3"
          vs-sm="4"
          vs-xs="12"
        >
          <h5>Time</h5>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="3"
          vs-sm="4"
          vs-xs="12"
        >
          <h5>{{ label }}</h5>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="3"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-input-number v-model="number" />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="3"
          vs-sm="4"
          vs-xs="12"
        >
          <!-- <h5 class="textSuccess"><b>17 °C</b></h5>  -->
          <vs-select class="selectExample" v-model="select1">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in options1"
            />
          </vs-select>
        </vs-col> </vs-row
      ><br />
      <vs-row
        ><vs-spacer />
        <vs-button
          color="success"
          @click="save"
          style="border-radius: 30px; width: 80px"
          type="filled"
          >Submit</vs-button
        >
        <vs-button
          class="ml-2"
          color="dark"
          @click="cancel_reset"
          style="border-radius: 30px; width: 80px"
          type="flat"
          >Cancel</vs-button
        ></vs-row
      >
    </vs-popup>
  </vs-row>
</template>

<script>
export default {
  props: ["value_time", "station"],
  data() {
    return {
      popupActivo: false,
      number: null,
      select1: 2,
      options1: [
        { text: "Min. ", value: 1 },
        { text: "Sec.", value: 2 },
      ],
      label: "",
    };
  },
  methods: {
    save() {
      let a = 0;
      if (this.select1 == 1) {
        a = Number(this.number) * 60;
        this.label = this.convertSeconds(a);
      } else {
        a = Number(this.number);
        this.label = this.convertSeconds(a);
      }
      this.$WSS.emit("FPS-demo-setting", {
        stasion: this.station,
        settings: Number(a),
      });
      console.log(a);
      this.popupActivo = false;
    },
    cancel_reset() {
      this.default_time();
      this.popupActivo = false;
    },
    convertSeconds(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);

      var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
      return hDisplay + mDisplay + sDisplay;
    },
    default_time() {
      this.popupActivo = true;
      if (Number(this.value_time) <= 60) {
        this.select1 = 2;
        this.number = this.value_time;
      } else {
        this.select1 = 1;
        this.number = this.value_time / 60;
      }
      this.label = this.convertSeconds(this.value_time);
    },
  },
  created() {
    // this.default_time();
  },
};
</script>

<style>
</style>